import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { JobMonitor } from '../components/jobs/JobMonitor';

export const JobMonitorPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const batchId = searchParams.get('batch_id');
  
  if (!batchId) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No batch ID provided for monitoring</p>
        <button 
          onClick={() => navigate('/jobs')}
          className="mt-4 px-4 py-2 bg-primary text-white rounded"
        >
          Back to Jobs
        </button>
      </div>
    );
  }

  const handleClose = () => {
    navigate('/jobs');
  };

  const handleViewJobs = () => {
    navigate(`/jobs?batch_id=${batchId}`);
  };

  const handleViewApproval = () => {
    navigate(`/jobs/approval?batch_id=${batchId}`);
  };

  const handleBulkReject = async (jobIds: string[], reason?: string) => {
    // TODO: Implement bulk reject functionality
    console.log('Bulk reject:', jobIds, reason);
  };

  return (
    <JobMonitor
      batchId={batchId}
      onClose={handleClose}
      onViewJobs={handleViewJobs}
      onViewApproval={handleViewApproval}
      onBulkReject={handleBulkReject}
    />
  );
};

export default JobMonitorPage;